/** Quante badge mostrare in base a altezza/larghezza card (evita sovrapposizioni). */
export const getMaxVisibleBadges = ({
  showIcons,
  isBreak,
  isMicroCard,
  isCompactCard,
  isMobile,
  taskHeight,
  widthBucket,
}) => {
  if (!showIcons || isBreak) return 0;
  // 15' su mobile (step 8px) è troppo basso; 30' (48px) deve comunque mostrare 1 badge.
  if (taskHeight < 36) return 0;
  if (isMicroCard || isCompactCard || taskHeight < 64 || widthBucket === 1) return 1;
  if (isMobile && taskHeight < 88) return 1;
  if (isMobile || taskHeight < 100) return 2;
  return 3;
};
